import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { Delete, Download } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DocumentInfoBlock, DocumentTitle } from 'components/common/documents-upload/DocumentCardBasic';
import {
  CardBodyStyled,
  CardHeaderStyled,
  CardStyled,
  TopSectionStyled,
} from 'components/common/documents-upload/DocumentCardBasic/styles';
import DocumentTag from 'components/common/documents-upload/DocumentTag';
import ActionsDropdown from 'components/common/general/ActionsDropdown';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRFQBenefitSummaryPageStore } from 'store/pages/rfq/rfq-template/rfq-benefit-summary/pageStore';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { DropdownOptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { WrapperStyled } from './styles';

const ActionDropdown: React.FC = observer(() => {
  const { isTemplateInProgress, isBenefitSummaryUploaded, openWarningModal, downloadDocument } =
    useRFQBenefitSummaryPageStore();

  const downloadDocumentOption: DropdownOptionType = {
    value: 'downloadDocument',
    label: 'Download Document',
    icon: Download,
    onOptionClick: downloadDocument,
  };

  const deleteDocumentOption: DropdownOptionType = {
    value: 'deleteDocument',
    customColor: 'red',
    label: 'Delete Document',
    icon: Delete,
    onOptionClick: openWarningModal,
  };

  return (
    <ActionsDropdown
      name="More Options"
      buttonTitle="More Options"
      buttonDisabled={!isBenefitSummaryUploaded}
      options={isTemplateInProgress ? [downloadDocumentOption, deleteDocumentOption] : [downloadDocumentOption]}
    />
  );
});

const RFQBenefitSummary: React.FC = observer(() => {
  const { isLoading, documentStatus, showWarningModal, closeWarningModal, removeDocument } =
    useRFQBenefitSummaryPageStore();

  return (
    <WrapperStyled>
      <OverlaySpinner display={isLoading} />
      <CardStyled $status={documentStatus}>
        <CardHeaderStyled>
          <DocumentTitle type="Benefit Summary" status={documentStatus} />
          <DocumentTag status={documentStatus} />
        </CardHeaderStyled>
        <CardBodyStyled>
          <TopSectionStyled>
            <DocumentInfoBlock
              label="Description"
              value="A document that outlines the key features of a health plan, including coverage, costs, and benefits in a simple, easy-to-read format."
            />
            <ActionDropdown />
          </TopSectionStyled>
        </CardBodyStyled>
      </CardStyled>

      <ActionModal
        title="Delete Uploaded Document"
        subtitle={
          <span>
            This action will permanently delete the benefit summary document
            <br /> and cannot be undone.
          </span>
        }
        show={showWarningModal}
        onClose={closeWarningModal}
        closeButtonText="Cancel"
        actionButtonText="Delete"
        onAction={removeDocument}
        modalType={ModalType.DELETE}
      />
    </WrapperStyled>
  );
});

export default RFQBenefitSummary;
